export enum LocationOrigin {
  Pending = "pending",
  Browser = "browser",
  Geotargetly = "geotargetly",
  Fallback = "fallback",
}
